import React from 'react';
import './QuantityBadge.less';

export const QuantityBadge = ({quantity}) => {
	return <b className="quantity-badge">{quantity}</b>;
};
